import { getTypeMedio } from "../medioTags"

export const getPlayersVoteByMedios = (medios, goldenBallInfo, phase, hasSpecialVote) => {
    const medioType = getTypeMedio(goldenBallInfo, hasSpecialVote)
   const medioFound =  goldenBallInfo?.[medioType]?.find(medio => medio?._id === hasSpecialVote)
    const playersVoted = medioFound?.votedBy?.[phase] || []
    const playersVotedIds = playersVoted?.map(player => player?.jugador) || []
    const playerPoints = playersVoted?.map(player => player?.voto) || []

    return {
        playersVotedIds,
        playerPoints
    }

}